import { render, staticRenderFns } from "./mHeader.vue?vue&type=template&id=0fbc0fcb&scoped=true"
import script from "./mHeader.vue?vue&type=script&lang=js"
export * from "./mHeader.vue?vue&type=script&lang=js"
import style0 from "./mHeader.vue?vue&type=style&index=0&id=0fbc0fcb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_064421c868bf9d44c080cdd6f5d40e10/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbc0fcb",
  null
  
)

export default component.exports